"use client";

import { Button } from "@/components/ui/button";
import { Download, FileText, File, FileCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AvailableDocuments() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const documents = [{
    id: 1,
    title: "Land Title Verification Documents",
    icon: FileCheck,
    fileUrl: "#"
  }, {
    id: 2,
    title: "East Legon Hills Collection Brochure",
    icon: FileText,
    fileUrl: "#"
  }, {
    id: 3,
    title: "Development Timeline & Progress Reports",
    icon: File,
    fileUrl: "#"
  }, {
    id: 4,
    title: "Investment Agreement Template",
    icon: FileText,
    fileUrl: "#"
  }, {
    id: 5,
    title: "Site Location & GPS Coordinates",
    icon: File,
    fileUrl: "#"
  }];
  return <section id="available-documents" ref={ref} className="py-24 bg-light-background">
      <div className="container mx-auto px-6 max-w-4xl">
        <div className={`mb-12 ${isVisible ? "animate-fade-in-up" : "opacity-0"}`}>
          <h2 className="font-display text-4xl font-bold text-primary mb-4">
            Available Documents
          </h2>
          <p className="text-foreground/70 text-lg">
            Access our comprehensive documentation library. All files are
            verified and ready for download.
          </p>
        </div>

        <div className="space-y-4">
          {documents.map((doc, i) => {
          const Icon = doc.icon;
          return <div key={doc.id} data-index={i} className={`group flex items-center gap-6 p-6 bg-secondary-light rounded-md border border-border shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
            animationDelay: isVisible ? `${i * 50}ms` : "0ms"
          }}>
                <div className="shrink-0">
                  <Icon className="size-8 text-accent transition-all duration-[var(--duration-fast)] group-hover:brightness-110" />
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-lg text-primary truncate">
                    {doc.title}
                  </h3>
                </div>

                <Button size="sm" variant="outline" className="shrink-0 group/btn hover:bg-accent/10 hover:border-accent hover:text-accent transition-all duration-[var(--duration-fast)]" onClick={() => {
              console.log(`Downloading: ${doc.title}`);
            }}>
                  <Download className="size-4 group-hover/btn:animate-pulse" />
                  Download
                </Button>
              </div>;
        })}
        </div>
      </div>
    </section>;
}